import { Flex } from '@chakra-ui/react'
import React from 'react'
import audioPlayerHelp from '~/assets/sounds/mango-audio-player-help-menu.mp3'
import Text from '~/components/core/Text'
import KeyboardKey from '~/components/KeyboardKey'
import { AudioPlayer } from '~/components/shared/AudioPlayer'
import { AudioPlayerVariant } from '~/components/shared/componentStyles/AudioPlayer.style'
import { StyledLine } from '~/components/StyledLine'

const KeyboardShortcutsDetailWrapper = ({ children }) => {
  return (
    <Flex
      width={'100%'}
      height={'100%'}
      padding={'1.875rem'}
      flexDir={'column'}
    >
      {children}
    </Flex>
  )
}

const TitleWrapper = ({ children }) => {
  return (
    <Flex alignItems={'center'} justifyContent={'center'} marginBottom={'1rem'}>
      {children}
    </Flex>
  )
}

const DetailWrapper = ({ children }) => {
  return (
    <Flex flex={1} marginTop={'1rem'}>
      {children}
    </Flex>
  )
}

const DetailColumn = ({ children }) => {
  return (
    <Flex
      flex={1}
      flexDir={'column'}
      alignItems={'center'}
      marginLeft={'3rem'}
      marginRight={'3rem'}
    >
      {children}
    </Flex>
  )
}

const Row = ({ children }) => {
  return (
    <Flex
      width="100%"
      alignItems="center"
      justifyContent="space-between"
      marginBottom="1rem"
    >
      {children}
    </Flex>
  )
}

const KeyboardButtonWrapper = ({ children }) => {
  return (
    <Flex gap="0.375rem">
      {React.Children.map(children, (child) => React.cloneElement(child))}
    </Flex>
  )
}

const AudioPlayerWrapper = ({ children }) => {
  return <Flex marginBottom={'1rem'}>{children}</Flex>
}

const KeyboardShortcutsDetail = () => {
  return (
    <KeyboardShortcutsDetailWrapper>
      <TitleWrapper>
        <Text text="Audio Player Keyboard Shortcuts" />
      </TitleWrapper>
      <AudioPlayerWrapper>
        <AudioPlayer
          variant={AudioPlayerVariant.Inline}
          audioUri={audioPlayerHelp}
          showInfoButton={false}
          answerTimestamp={5251}
          showDownloadButton
        />
      </AudioPlayerWrapper>
      <StyledLine marginTop={10} marginBottom={10} />
      <DetailWrapper>
        <DetailColumn>
          <Row>
            <KeyboardButtonWrapper>
              <KeyboardKey text="Space Bar" />
            </KeyboardButtonWrapper>
            <Text color="black" text="Play / Pause" />
          </Row>
          <Row>
            <KeyboardButtonWrapper>
              <KeyboardKey text="M" />
            </KeyboardButtonWrapper>
            <Text color="black" text="Mute / Unmute" />
          </Row>
          <Row>
            <KeyboardButtonWrapper>
              <KeyboardKey text="<" />
            </KeyboardButtonWrapper>
            <Text color="black" text="Rewind 10s" />
          </Row>
          <Row>
            <KeyboardButtonWrapper>
              <KeyboardKey text=">" />
            </KeyboardButtonWrapper>
            <Text color="black" text="Advance 10s" />
          </Row>
          <Row>
            <KeyboardButtonWrapper>
              <KeyboardKey text="Shift" />
              <KeyboardKey text="<" />
            </KeyboardButtonWrapper>
            <Text color="black" text="Rewind 3s" />
          </Row>
          <Row>
            <KeyboardButtonWrapper>
              <KeyboardKey text="Shift" />
              <KeyboardKey text=">" />
            </KeyboardButtonWrapper>
            <Text color="black" text="Advance 3s" />
          </Row>
        </DetailColumn>
      </DetailWrapper>
    </KeyboardShortcutsDetailWrapper>
  )
}

export default KeyboardShortcutsDetail
